import {connect, reducerAndActionsFor} from '@symbolic/redux'; //eslint-disable-line

export {connect, reducerAndActionsFor};
